import { ICopyable } from '../controls/common/icopyable';
import { IBoxGroup } from './interfaces/box-group.interface';
import { IDisplayableItem } from './interfaces/displayable-item.interface';
import { ISortable } from './interfaces/sortable.interface';

export class BoxGroup implements ICopyable<BoxGroup>, ISortable, IDisplayableItem {
    id: string = null;
    name: string = null;
    viewId: number = null;
    order: number = null;

    public createCopy(): BoxGroup {
        const instance = new BoxGroup();
        instance.id = this.id;
        instance.name = this.name;
        instance.viewId = this.viewId;
        instance.order = this.order;

        return instance;
    }

    public static createFormCopy(box: BoxGroup): IBoxGroup {
        const instance = new BoxGroup();
        instance.id = box.id;
        instance.name = box.name;
        instance.viewId = box.viewId;
        instance.order = box.order;

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.name = other.name;
        this.viewId = other.viewId;
        this.order = other.order;
    }

    public getDisplayName() {
        return `${this.name}`;
    }

    get displayName(): string {
        return `${this.name}`;
    }
}
